import script from "./index-review.vue?vue&type=script&setup=true&lang=js"
export * from "./index-review.vue?vue&type=script&setup=true&lang=js"

import "./index-review.vue?vue&type=style&index=0&id=277057f9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277057f9"]])

export default __exports__